/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Authenticate/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import * as fromFlow from 'Simple/Flow'
import Button from 'DesignSystem/Button/index'
import GreyfinchBird from 'DesignSystem/Svgs/GreyfinchBird/index'
import Invalid from './Invalid/index'
import Loading from './Loading/index'
import MaskedInput from 'DesignSystem/MaskedInput/index'
import No from './No/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Authenticate({
  children,
  viewPath = "/App/Authenticate",
  onChange,
  onFocus,
  value,
  onSubmit,
  isDisabled
  
}) {
  let isBefore = useIsBefore()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<div
  data-testid="Authenticate.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-2eazAI': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="Authenticate.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
Please provide the authentication code for your location
</span>
<MaskedInput
  viewPath={`${viewPath}/MaskedInput`}
 alignSelf="center"
 autoFocus={true}
 mask="sixDigits"
 onChange={onChange}
 onFocus={onFocus}
 textTransform="none"
 type="number"
 fontSize={60}
 textAlign="center"
 initialValue={value}
 paddingRight={0}
 onSubmit={onSubmit}
 width={340}
 marginTop={32}
 marginBottom={10}
/>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Invalid'}>
<Invalid
  viewPath={`${viewPath}/Invalid`}
/>
</fromFlow.When>
<Button
  viewPath={`${viewPath}/Button`}
 alignSelf="center"
 onClick={onSubmit}
 isDisabled={isDisabled}
 marginLeft={0}
 marginTop={80}
 text="Authenticate This Device"
/>
</div>
<div
  data-testid="Authenticate.Logo"
  data-view-path={viewPath}
 className={`views-block ${styles.Logo}`}
>
<GreyfinchBird
  viewPath={`${viewPath}/GreyfinchBird`}
 height={42}
 width={42}
/>
<span
  data-testid="Authenticate.Text:1"
  data-view-path={viewPath}
 className={`views-text ${styles.Text1}`}
>
Powered by Greyfinch
</span>
</div>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}